import { useAuth, RedirectToSignIn } from '@clerk/clerk-react'
import OutlineView from '../components/OutlineView'
import TeamGate from '../components/TeamGate'

export default function OutlinePage() {
  const { isSignedIn, isLoaded } = useAuth()
  if (!isLoaded) return null
  if (!isSignedIn) return <RedirectToSignIn />
  return <TeamGate><OutlineView /></TeamGate>
}
